<template>
  <div class="c-refresh">
    <div class="c-inline-text">
      <span class="c-txt-title"></span>
      <span></span>
    </div>
    <Button type="text" @click="getData" :loading="$store.state.Convert.syncing">
      <span v-if="$store.state.Convert.syncing">刷新中...</span>
      <span v-else>
        <Tooltip ref="tooltip" :content="`最后更新时间：${$store.state.Convert.syncDate}`" placement="left" transfer>
          <Icon type="md-sync" size="16" />
          <span>刷新</span>
        </Tooltip>
      </span>
    </Button>
  </div>
</template>
<script>
import { syncAdInfo } from '@/api/convert.model'
import { mapActions } from 'vuex'
export default {
  name: 'refresh',
  methods: {
    ...mapActions('Convert', ['handleAsync']),
    getData() {
      this.$store.commit('Convert/setSyncing', true)
      syncAdInfo({
        mediaId: this.$store.state.Convert.media
      }).then((data) => {
        this.$store.commit('Convert/setSyncing', false)
        if (data) {
          this.$store.commit('Convert/setSyncDate', data)
          this.$nextTick(() => {
            this.$refs.tooltip.handleShowPopper()
            setTimeout(() => {
              this.$refs.tooltip.handleClosePopper()
            }, 3000)
          })
        }
      })
    }
  },
  created() {
    this.handleAsync()
  }
}
</script>
<style lang="scss" scoped>
.c-refresh {
  font-size: 14px;

  .c-inline-text {
    display: inline-block;
    padding-right: 12px;
  }

  .c-txt-title {
    font-weight: 600;
  }

  ::v-deep .ivu-btn:hover {
    background-color: transparent;
  }

  ::v-deep .ivu-btn.ivu-btn-loading {
    &:before {
      background-color: transparent;
    }
  }
}
</style>
